
import { FC, useContext, useEffect } from 'react';

import { LoadingActionContext } from '@/contexts/layouts/LoadingActionContext';
import { DefaultInstitutionCreateLink, DefaultParticipantCreateLink, DefaultTrialCreateLink, ILinkContext, LinkContext } from '@/contexts/layouts/LinkContext';

interface ISetLinksProps {
    createTrialLink?: ILinkContext['createTrialLink'];
    createInstitutionLink?: ILinkContext['createInstitutionLink'];
    createParticipantLink?: ILinkContext['createParticipantLink'];
    trialLinkEnabled?: ILinkContext['trialLinkEnabled'];
    institutionLinkEnabled?: ILinkContext['institutionLinkEnabled'];
    participantLinkEnabled?: ILinkContext['participantLinkEnabled'];
}

const SetLinks: FC<ISetLinksProps> = ({
    createTrialLink,
    createInstitutionLink,
    createParticipantLink,
    trialLinkEnabled,
    institutionLinkEnabled,
    participantLinkEnabled
}) => {

    const { setCreateInstitutionLink, setCreateTrialLink, setInstitutionLinkEnabled, setTrialLinkEnabled, setCreateParticipantLink, setParticipantLinkEnabled } = useContext(LinkContext);

    useEffect(() => {
        if (createTrialLink) {
            setCreateTrialLink(createTrialLink);

            return () => {
                setCreateTrialLink(DefaultTrialCreateLink)
            }
        }
    }, [setCreateTrialLink, createTrialLink])

    useEffect(() => {
        if (createInstitutionLink) {
            setCreateInstitutionLink(createInstitutionLink);

            return () => {
                setCreateInstitutionLink(DefaultInstitutionCreateLink)
            }
        }
    }, [setCreateInstitutionLink, createInstitutionLink])

    
    useEffect(() => {
        if (createParticipantLink) {
            setCreateParticipantLink(createParticipantLink);

            return () => {
                setCreateParticipantLink(DefaultParticipantCreateLink)
            }
        }
    }, [setCreateParticipantLink, createParticipantLink])

    useEffect(() => {
        if (trialLinkEnabled !== undefined) {
            setTrialLinkEnabled(trialLinkEnabled);

            return () => {
                setTrialLinkEnabled(true)
            }
        }
    }, [setTrialLinkEnabled, trialLinkEnabled])

    useEffect(() => {
        if (institutionLinkEnabled !== undefined) {
            setInstitutionLinkEnabled(institutionLinkEnabled);

            return () => {
                setInstitutionLinkEnabled(true)
            }
        }
    }, [setInstitutionLinkEnabled, institutionLinkEnabled])

    useEffect(() => {
        if (participantLinkEnabled !== undefined) {
            setParticipantLinkEnabled(participantLinkEnabled);

            return () => {
                setParticipantLinkEnabled(true)
            }
        }
    }, [setParticipantLinkEnabled, participantLinkEnabled])

    return null;
}

export default SetLinks